<template>
  <div class="container-fluid map">
    <div class="MapContainer container">
      <div class="GoogleMapContainer col-xl-7 col-12">
        <div class="Maps col-xl-12 col-sm-12" id="Maps" />
      </div>

      <div class="panelContainer container col-xl-5">
        <div class="panelContainerContent col-12">
          <div class="cityContainer col-12">
            <div
              class="col-6  col-sm-4 col-md-2  col-lg-2 col-xl-3 radiusSearch"
            >
              <b-button @click="searchNearest">Szukaj</b-button>
            </div>
            <div class="col-6 col-sm-4  col-md-2 col-lg-2 col-xl-3 mapReset">
              <b-button @click="mapReset" variant="danger">Reset</b-button>
            </div>
            <div
              class="col-4 offset-1 offset-sm-1 col-sm-4 offset-md-0 col-md-3 col-lg-2 col-xl-3 radiusText"
            >
              Zakres(KM)
            </div>
            <div class="col-5 col-sm-5 col-md-5 col-lg-3 col-xl-3 radiusValue">
              <b-form-input
                v-model="radius"
                placeholder="Liczba KM"
                @keydown.enter.native="searchNearest"
                @click="$v.radius.$touch()"
                :class="{ invalid: $v.radius.$error }"
              ></b-form-input>
            </div>
            <div class="col-sm-12 col-lg-5 col-xl-12 radiusCity">
              <b-form-input
                class="cityInputForm"
                v-model="city"
                placeholder="Wprowadź miejsce..."
                @keydown.enter.native="searchNearest"
                @click="$v.city.$touch()"
                :class="{ invalid: $v.city.$error }"
              ></b-form-input>
            </div>
          </div>
          <div class="placeCardContainer container">
            <div
              v-for="(place, index) in locationsNearby"
              :key="index"
              class="placeCard col-12 col-lg-6 col-xl-12"
              v-html="place.description"
              @click="centerSelectedListPlace(place)"
            ></div>
            <div
              v-if="locationsNearby.length == 0"
              class="placeCard col-12 col-lg-6 col-xl-12 emptyPlaceCard"
            >
              <p>Brak wyników w wskazanym obszarze</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gmap from "./gmaps";
import location from "./location";
import { required, numeric } from "vuelidate/lib/validators";
const isPositive = value => value > 0;
export default {
  validations: {
    city: {
      required
    },
    radius: {
      required,
      numeric,
      isPositive
    }
  },

  data() {
    return {
      google: "",
      geocoder: "",
      map: "",
      locations: "",
      city: "",
      radius: "50",
      markers: [],
      locationsNearby: []
    };
  },

  async created() {
    try {
      this.locations = "";
      this.locationsNearby = [];
      this.google = await gmap.init();

      this.map = new this.google.maps.Map(document.getElementById("Maps"), {
        zoom: 5,
        center: { lat: 51.919438, lng: 19.145136 }
      });
      await location.addFinalData();
      this.locations = location.locationFinalData;

      this.addMarkers(this.locations);
      this.setMapOnAll(this.map);
      this.locationsNearby = this.locations;
    } catch (error) {
      console.error(error);
    }
  },
  methods: {
    mapReset() {
      this.locations = "";
      this.locationsNearby = [];
      this.map = new this.google.maps.Map(document.getElementById("Maps"), {
        zoom: 5,
        center: { lat: 51.919438, lng: 19.145136 }
      });
      this.locations = location.locationFinalData;
      this.addMarkers(this.locations);
      this.setMapOnAll(this.map);
      this.locationsNearby = this.locations;
    },
    setByDistance() {
      this.clearMarkers();
    },
    setMapOnAll(map) {
      let bounds = new this.google.maps.LatLngBounds();
      this.markers.forEach(mark => {
        mark.setMap(map);
        bounds.extend(mark.getPosition());
      });

      if (this.markers.length > 1) this.map.fitBounds(bounds);
    },

    clearMarkers() {
      this.setMapOnAll(null);
    },
    addMarkers(loc) {
      this.markers = [];
      const places = loc;

      places.forEach(element => {
        let infowindow = new this.google.maps.InfoWindow({
          content: element.description
        });
        let marker = new this.google.maps.Marker({
          position: element.coordinates,
          map: this.map
        });
        marker.addListener("click", function() {
          if (infowindow.getMap()) {
            infowindow.close(this.map, marker);
          } else {
            infowindow.open(this.map, marker);
          }
        });

        this.markers.push(marker);
      });
    },
    searchByName(city) {
      try {
        const geocoder = new this.google.maps.Geocoder();
        geocoder.geocode({ address: city }, (results, status) => {
          if (status !== "OK" || !results[0]) {
            throw new Error(status);
          }
          this.map.setCenter(results[0].geometry.location);
          return new this.google.maps.LatLng(
            results[0].geometry.location.lat(),
            results[0].geometry.location.lng()
          );
        });
      } catch (error) {
        return console.error(error);
      }
    },

    searchNearest() {
      this.$v.city.$touch();
      this.$v.radius.$touch();
      if (this.$v.city.$error == true || this.$v.radius.$error == true) return;

      this.clearMarkers();
      this.locations = "";
      this.locations = location.locationFinalData;
      this.locationsNearby = [];
      this.geocoder = new this.google.maps.Geocoder();
      const self = this;

      findLatLang(this.city, this.geocoder).then(function(returnVals) {
        selectPlacesInRadius(returnVals);
      });

      function findLatLang(city, geocoder) {
        return new Promise(function(resolve, reject) {
          geocoder.geocode({ address: city }, function(results, status) {
            if (status === "OK") {
              self.map.setCenter(results[0].geometry.location);
              self.map.setZoom(7);
              resolve([
                results[0].geometry.location.lat(),
                results[0].geometry.location.lng()
              ]);
            } else {
              reject(new Error("Couldnt't find the location " + city));
            }
          });
        });
      }

      function selectPlacesInRadius(selectedLocation) {
        return new Promise(function(resolve, reject) {
          let myPlace = new self.google.maps.LatLng(
            selectedLocation[0],
            selectedLocation[1]
          );

          if (myPlace == undefined) {
            reject(new Error("No data for selected location"));
          }
          const computeDistance = async () => {
            for (const element of self.locations) {
              let distiributionPlace = new self.google.maps.LatLng(
                element.coordinates.lat,
                element.coordinates.lng
              );
              element.distance = await self.google.maps.geometry.spherical.computeDistanceBetween(
                myPlace,
                distiributionPlace
              );
            }
          };
          computeDistance()
            .then(() => {
              self.locations.forEach(element => {
                element.distance = (element.distance / 1000).toFixed(2);

                if (element.distance * 1 <= self.radius) {
                  self.locationsNearby.push(element);
                }
              });
              self.addMarkers(self.locationsNearby);
              self.setMapOnAll(self.map);
            })
            .then(() => resolve());
        });
      }
    },
    centerSelectedListPlace(myPlace) {
      this.map.setCenter({
        lat: myPlace.coordinates.lat,
        lng: myPlace.coordinates.lng
      });
      this.map.setZoom(10);
    },
    checkArray() {
      console.dir(this.locationsNearby);
    }
  }
};
</script>

<style>
.map {
  background-color: #fff;
  padding-top: 1%;
  padding-bottom: 2%;
}

.placeCard {
  margin-top: 1%;
  padding-top: 3%;
  padding-bottom: 2%;
  border: solid;
  background-color: #000000;
  color: white;
  transition: background-color 0.75s ease;
  opacity: 0;
  animation: showPlaceCard 0.5s;
  animation-fill-mode: forwards;
  animation-delay: 0.25s;
}
@keyframes showPlaceCard {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.placeCard #firstHeading {
  font-size: 1.5rem;
}
.placeCard a {
  color: inherit;
}
.placeCard:hover {
  background-color: #fff;
  color: black;
  cursor: pointer;
}
.placeCardContainer::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}
.placeCardContainer::-webkit-scrollbar-track {
  background: white;
}
.placeCardContainer::-webkit-scrollbar-thumb {
  background: #ddd;
  visibility: hidden;
}
.placeCardContainer:hover::-webkit-scrollbar-thumb {
  visibility: visible;
}
.placeCardContainer {
  margin-top: 2%;
  display: flex;
  flex-wrap: wrap;
  max-height: 380px;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}
.placeCardContainer:hover {
  scrollbar-width: thin;
  scrollbar-color: auto;
}
.cityContainer {
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.cityContainer div {
  margin-top: 3%;
}
.GoogleMapContainer {
  overflow: hidden;
  position: relative;
  height: 50vh;
  margin-bottom: 2%;
}
.Maps {
  left: 0;
  top: 0;
  height: inherit;
  width: 100%;
  position: relative;
}

.panelContainer {
  display: flex;
  flex-direction: column;
}
.MapContainer {
  display: flex;
  flex-direction: row-reverse;
}

.radiusCity {
  order: -1;
}
.radiusSearch {
  order: 1;
  flex-basis: 100%;
}
.mapReset {
  order: 1;
  flex-basis: 100%;
}

@media (max-width: 1199px) {
  .MapContainer {
    flex-direction: column;
  }
  .cityContainer {
    flex-direction: row;
  }
  .radiusCity {
    order: 0;
  }
  .radiusSearch {
    order: 0;
  }
  .mapReset {
    order: 0;
  }
  .GoogleMapContainer {
    height: 50vh;
  }
}
</style>
